/* eslint-disable jsx-a11y/anchor-has-content */
import React from "react";

export const LeftContainer = React.memo(
    () => {
        console.log("Render of left container called!");

        Game.Rewards.ShowInGameLeft();

        // const screenHeight = window.innerHeight;
        // const shouldUseSmallContainers = screenHeight <= 600;

        const styles = {
            border: window.location.href.includes("localhost") ? "1px solid red" : "none",
            display: "flex",
            width: "160px",
            height: "600px"
        };

        return (
            <div className="left-container">
                <div className="left-container-inner" id="pvpz-io_160x600_1" style={styles}></div>
            </div>
        );
    },
    (__prepProps, __nextProps) => true
);
